var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page404)?_c('Page404'):(_vm.teamData)?_c('div',{staticClass:"team"},[_c('XNav',{attrs:{"content":[
      { t: 'common.teams' },
      { name: _vm.teamName },
    ]}}),_c('TeamBanner',{attrs:{"team-name":_vm.teamName,"team-id":_vm.$route.params.id}}),_c('TeamOverviewTable',{attrs:{"content":_vm.teamData,"team-id":_vm.$route.params.id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }